exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.uk-button.uk-button-danger {\n  font-size: 14px; }\n\n.edit-doc #body {\n  font-size: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/dzongkha/dzongkha-view/dzongkha-view.component.scss
// module id = ../../../../../src-admin/app/components/dzongkha/dzongkha-view/dzongkha-view.component.scss
// module chunks = main